<template>
	<div class="layout-inner pg_content course_about">

    <navbar></navbar>

    <div class="layout-container">
      <div class="layout-content">

      	<template v-if="isLoading">
          <div class="w-100" style="padding: 150px 0;">
            <spinner size="large"></spinner>
          </div>
        </template>

        <template v-else>

					<template v-if="career && career.name">
            <career-title :career="career"></career-title>
          </template>

          <div class="container-fluid flex-grow-1 pg_content_container">
            <div class="row">
              <div class="container">

								<div class="row result_row">

									<div class="col-4 thumbnail_container">
										<div class="thumbnail_container_inner">
											<img class="thumb_img"
												v-if="career.thumbnailURI"
												:src="career.thumbnailURI"
												tabindex="0"
												onerror="this.onerror=null;this.src='https://pragya2.s3-us-west-2.amazonaws.com/soc-svg/career-default.svg';">
											<div v-else class="default_thumb">
												<span class="ic ic-career"></span>
											</div>
										</div>
									</div>

									<div class="col-8 entity_details">

                    <div v-if="showMedianIncome" class="row">
                      <div class="label">{{medianIncomeLabel}}</div>
                      <div class="val" v-if="career.medianIncomePerYear">
                        {{currencyLabel}} <span v-html="addCommaInNumber(career.medianIncomePerYear)"></span>
                      </div>
                      <div class="val no-data" v-else>
												<span class="no_data_msg2">Data Unavailable</span>
											</div>
                    </div>

                    <div class="row" v-if="showJobPostings">
                      <div class="label">{{jobPostingsLabel}}</div>
                      <div class="val" v-if="career.openings">
                        <span v-html="addCommaInNumber(career.openings)"></span>
                      </div>
                      <div class="val no-data" v-else>
												<span class="no_data_msg2">Data Unavailable</span>
											</div>
                    </div>

                    <div v-if="showGrowthRate" class="row">
                      <div class="label">{{growthRateLabel}}</div>
                      <div class="val" v-if="career.growth">
												<span v-html="formatNumericVal(career.growth)"></span>%
											</div>
                      <div class="val no-data" v-else>
												<span class="no_data_msg2">Data Unavailable</span>
											</div>
                    </div>
                  </div>

								</div>

              </div>
            </div>

            <div class="row">
							<div class="col-12">
              	<career-menu :code="code" :pageTitle="pageTitle" :returnTo="returnTo" :isComingFromBookmark="isComingFromBookmark"></career-menu>
            	</div>
						</div>

          </div>
        </template>

        <career-footer-navbar :pageTitle="pageTitle" :returnTo="returnTo" :params="{isComingFromBookmark: isComingFromBookmark}"></career-footer-navbar>

			</div>
    </div>
  </div>
</template>

<script>
  import { mapState, mapActions } from 'vuex'
  import CareerTitle from './CareerTitle'
  import { PACKAGE } from '../../../package_constants'
  import { PackageUtil } from '../../../package_utils'
  import Navbar from '../../misc/components/./Navbar'
  import CareerMenu from './CareerMenu'
  import CareerFooterNavbar from '../../misc/components/./CareerFooterNavbar'

  export default {
    name: 'career-home',
    props: ['code', 'isComingFromBookmark'],
    components: {
      Navbar,
      CareerMenu,
      CareerTitle,
      CareerFooterNavbar
    },
    data: () => {
      return {
        isLoading: true
      }
    },

    mounted () {
      this.loadCareerDetail()
    },

    methods: {
      ...mapActions([
        'loadCareer',
        'loadUserObj',
        'loadInstitutionPackage'
      ]),
      async loadCareerDetail () {
        await this.loadUserObj()
        await this.loadInstitutionPackage({uuid: this.userObj.institutionId, isAggregated: false})
        await this.loadCareer(this.code)
        this.isLoading = false
      },
      getExploreSearchPackage () {
        let packages = this.packages
        if (!packages || !packages.length || packages.length <= 0) {
          return {}
        }
        return PackageUtil.getExploreSearchPackage(packages)
      },
      addCommaInNumber (value) {
        return Number(value).toLocaleString()
      },
			formatNumericVal (numValue) {
				return parseFloat(numValue).toFixed(1)
			},
	    hideUserNamePopup () {
	      this.$refs.userNamePopupContainer.$emit('close')
	    }
    },
    computed: {
      ...mapState({
        'career': state => state.career.careerObject,
        'userObj': state => state.login.userObj,
        'enabledFeatures': state => state.dashboard.enabledFeatures,
        'packages': state => state.dashboard.packages
      }),
      returnTo () {
        if (this.isComingFromBookmark) {
          return this.$route.query.returnTo || 'bookmarks'
        }
        return this.$route.query.returnTo || 'exploreCareerResults'
      },
      pageTitle () {
        if (this.isComingFromBookmark) {
          return this.$route.query.pageTitle || 'Back To Bookmarks'
        }
        return this.$route.query.pageTitle || 'Back To Careers'
      },
      exploreCareerDetailFlagMap () {
        let featureId = PACKAGE.FEATURE_IDS.EXPLORE_CAREER_DETAIL
        let exploreSearchPackage = this.getExploreSearchPackage()
        return PackageUtil.getFlagsFromPackageFeature(exploreSearchPackage, featureId)
      },
      showMedianIncome () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.enabled
      },
      medianIncomeLabel () {
        const defaultLabel = 'median income'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryMedianIncome.label || defaultLabel
      },
      showJobPostings () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.enabled
      },
      jobPostingsLabel () {
        const defaultLabel = 'job postings'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryJobPostings) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryJobPostings.label || defaultLabel
      },
      showGrowthRate () {
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return false
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.enabled
      },
      growthRateLabel () {
        const defaultLabel = 'growth rate'
        let exploreCareerDetailFlagMap = this.exploreCareerDetailFlagMap
        if (!exploreCareerDetailFlagMap || !exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate) {
          return defaultLabel
        }
        return exploreCareerDetailFlagMap.careerDetailSummaryGrowthRate.label || defaultLabel
      },
      currencyLabel () {
        return '$'
      }
    }
  }
</script>

<style scoped>
</style>



// WEBPACK FOOTER //
// src/app/career/components/CareerHome.vue